module.exports = __webpack_public_path__ + "img/temp.a2557300.svg";